import { render, staticRenderFns } from "./automations-loader.vue?vue&type=template&id=d46a1cec"
import script from "./automations-loader.vue?vue&type=script&lang=js"
export * from "./automations-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports